(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrimera-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nutri').forEach((root) => {
    if (root.dataset.nutriBound) return;
    root.dataset.nutriBound = 'true';
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('.nutri__tab');
      if (!tab) return;
      const group = tab.closest('.nutri__inner');
      if (!group) return;

      group.querySelectorAll('.nutri__tab').forEach((el) => {
        el.classList.remove('is-active');
        el.setAttribute('aria-selected', 'false');
      });
      group.querySelectorAll('.nutri__panel').forEach((el) => el.classList.remove('is-active'));

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      const panel = group.querySelector('#' + CSS.escape(tab.dataset.panel));
      if (panel) panel.classList.add('is-active');
    });
  });

  // Sizes and positions the custom scroll bar under the comparison table.
  document.querySelectorAll('[data-nutri-scroll]').forEach((scroller) => {
    if (scroller.dataset.nutriScrollBound) return;
    scroller.dataset.nutriScrollBound = 'true';
    const track = scroller.nextElementSibling;
    if (!track || !track.classList.contains('nutri__track')) return;
    const thumb = track.querySelector('.nutri__thumb');

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const scrollable = max > 1;
      track.classList.toggle('is-scrollable', scrollable);
      if (!scrollable) return;
      const trackWidth = track.clientWidth;
      const thumbWidth = Math.max(trackWidth * (scroller.clientWidth / scroller.scrollWidth), 32);
      const x = (scroller.scrollLeft / max) * (trackWidth - thumbWidth);
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    };

    scroller.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(scroller);
    else window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrimera-pdp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.npdp').forEach((root) => {
    if (root.dataset.npdpBound) return;
    root.dataset.npdpBound = 'true';

    const main = root.querySelector('.npdp__main-img');
    root.querySelectorAll('.npdp__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main || !thumb.dataset.full) return;
        main.src = thumb.dataset.full;
        main.removeAttribute('srcset');
        root.querySelectorAll('.npdp__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const variantInput = root.querySelector('.npdp__variant-input');
    root.querySelectorAll('.npdp__size').forEach((size) => {
      size.addEventListener('click', () => {
        if (size.hasAttribute('disabled')) return;
        root.querySelectorAll('.npdp__size').forEach((s) => {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        size.classList.add('is-selected');
        size.setAttribute('aria-checked', 'true');
        if (variantInput && size.dataset.variant) variantInput.value = size.dataset.variant;
      });
    });

    const input = root.querySelector('.npdp__qty-input');
    root.querySelectorAll('[data-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const current = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, button.dataset.qty === 'up' ? current + 1 : current - 1);
      });
    });
  });

  // ---------- cart drawer ----------
  // Progressive enhancement: without JS the product form posts to /cart as usual.
  (() => {
    const drawer = document.querySelector('[data-npdp-cart]');
    if (!drawer || drawer.dataset.npdpCartBound) return;
    drawer.dataset.npdpCartBound = 'true';

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const moneyFormat = drawer.dataset.moneyFormat || '';
    const sizeLabel = drawer.dataset.sizeLabel || '';
    const productId = Number(drawer.dataset.productId);

    const panel = drawer.querySelector('.npdp-cart__panel');
    const list = drawer.querySelector('[data-npdp-cart-items]');
    const empty = drawer.querySelector('[data-npdp-cart-empty]');
    const foot = drawer.querySelector('[data-npdp-cart-foot]');
    const errorBox = drawer.querySelector('[data-npdp-cart-error]');
    const subtotal = drawer.querySelector('[data-npdp-cart-subtotal]');
    const filled = drawer.querySelectorAll('[data-npdp-cart-filled]');
    let lastFocus = null;

    const esc = (value) =>
      String(value == null ? '' : value).replace(/[&<>"']/g, (c) =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
      );

    const group = (amount, decimals, thousands, decimal) => {
      const [whole, fraction] = amount.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };

    const money = (cents) => {
      const amount = (Number(cents) || 0) / 100;
      if (!moneyFormat) return '$' + group(amount, 2, ',', '.');
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals': return group(amount, 0, ',', '.');
          case 'amount_with_comma_separator': return group(amount, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(amount, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return group(amount, 2, "'", '.');
          default: return group(amount, 2, ',', '.');
        }
      });
    };

    const request = async (path, options = {}) => {
      const headers = { Accept: 'application/json' };
      if (options.json) headers['Content-Type'] = 'application/json';
      const response = await fetch(root + path, {
        method: options.method || 'GET',
        headers,
        body: options.json ? JSON.stringify(options.json) : options.body,
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
      return data;
    };

    const showError = (message) => {
      errorBox.textContent = message || '';
      errorBox.hidden = !message;
    };

    const thumb = (url) => (url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '');

    const lineMeta = (item) => {
      if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
      return item.product_id === productId ? sizeLabel : '';
    };

    const render = (cart) => {
      document.querySelectorAll('[data-npdp-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });

      const hasItems = cart.item_count > 0;
      empty.hidden = hasItems;
      foot.hidden = !hasItems;
      filled.forEach((el) => {
        el.hidden = !hasItems;
      });
      subtotal.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);

      list.innerHTML = cart.items
        .map((item, index) => {
          const meta = lineMeta(item);
          const name = esc(item.product_title);
          const line = index + 1;
          return (
            '<li class="npdp-cart__item">' +
              '<div class="npdp-cart__thumb">' +
                (item.image ? '<img src="' + esc(thumb(item.image)) + '" alt="' + name + '" width="64" height="64">' : '') +
                '<span class="npdp-cart__badge" aria-hidden="true">' + item.quantity + '</span>' +
              '</div>' +
              '<div class="npdp-cart__info">' +
                '<p class="npdp-cart__name">' + name + '</p>' +
                (meta ? '<p class="npdp-cart__meta">' + esc(meta) + '</p>' : '') +
              '</div>' +
              '<div class="npdp-cart__right">' +
                '<p class="npdp-cart__price">' + esc(money(item.final_line_price)) + '</p>' +
                '<div class="npdp-cart__qty">' +
                  '<button type="button" data-line="' + line + '" data-to="' + (item.quantity - 1) + '" aria-label="' +
                    (item.quantity === 1 ? 'Remove ' : 'Decrease quantity of ') + name + '">&minus;</button>' +
                  '<span aria-live="polite">' + item.quantity + '</span>' +
                  '<button type="button" data-line="' + line + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity of ' + name + '">+</button>' +
                '</div>' +
              '</div>' +
            '</li>'
          );
        })
        .join('');
    };

    const refresh = async () => render(await request('cart.js'));

    const setBusy = (busy) => panel.classList.toggle('is-busy', busy);

    const focusables = () =>
      [...panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), summary')].filter(
        (el) => el.offsetParent !== null
      );

    const open = (returnTo) => {
      if (drawer.classList.contains('is-open')) return;
      lastFocus = returnTo || document.activeElement;
      drawer.classList.add('is-open');
      document.documentElement.classList.add('npdp-cart-locked');
      requestAnimationFrame(() => drawer.querySelector('.npdp-cart__close').focus());
    };

    const close = () => {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('npdp-cart-locked');
      if (lastFocus && lastFocus !== document.body && document.contains(lastFocus)) {
        lastFocus.focus();
      } else if (drawer.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    };

    const mutate = async (path, json) => {
      setBusy(true);
      showError('');
      try {
        render(await request(path, { method: 'POST', json }));
      } catch (error) {
        showError(error.message);
      } finally {
        setBusy(false);
      }
    };

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-npdp-cart-close]')) {
        close();
        return;
      }
      const step = event.target.closest('[data-line]');
      if (step) {
        mutate('cart/change.js', { line: Number(step.dataset.line), quantity: Math.max(0, Number(step.dataset.to)) });
        return;
      }
      if (event.target.closest('[data-npdp-cart-clear]')) mutate('cart/clear.js', {});
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const promo = drawer.querySelector('[data-npdp-cart-promo]');
    if (promo) {
      promo.addEventListener('submit', (event) => {
        event.preventDefault();
        const code = promo.elements.discount.value.trim();
        if (!code) return;
        window.location.href =
          root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout');
      });
    }

    document.querySelectorAll('[data-npdp-cart-open]').forEach((link) => {
      link.addEventListener('click', async (event) => {
        event.preventDefault();
        showError('');
        open(link);
        try {
          await refresh();
        } catch (error) {
          showError(error.message);
        }
      });
    });

    const form = document.querySelector('.npdp__form');
    if (form) {
      let adding = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (adding) return;
        adding = true;
        const button = form.querySelector('.npdp__cta');
        const label = button ? button.textContent : '';
        if (button) {
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          button.textContent = 'Adding…';
        }
        showError('');
        try {
          await request('cart/add.js', { method: 'POST', body: new FormData(form) });
          await refresh();
        } catch (error) {
          showError(error.message);
          try {
            await refresh();
          } catch (_) {}
        } finally {
          if (button) {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            button.textContent = label;
          }
          adding = false;
          open(button || form);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
